export default "__VITE_ASSET__BCoUnctg__"